import React from "react";
import { Field, FieldArray } from "formik";
import PropTypes from "prop-types";
import { spaceShape } from "shapes";

import ProposalSpace from "./ProposalSpace";

const ProposalSpaces = ({ defaultUnits, spaces, values }) => (
  <FieldArray
    name="spaces"
    render={(arrayHelpers) =>
      values.spaces.map((space, index) => (
        <Field
          component={ProposalSpace}
          defaultUnits={defaultUnits}
          index={index}
          key={index}
          name={`spaces[${index}]`}
          onAdd={() => arrayHelpers.push({})}
          onRemove={() => {
            arrayHelpers.remove(index);
            if (index === 0) arrayHelpers.push({});
          }}
          space={space}
          spaces={spaces}
        />
      ))
    }
  />
);

ProposalSpaces.propTypes = {
  spaces: PropTypes.arrayOf(PropTypes.shape(spaceShape)),
  defaultUnits: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    period: PropTypes.string.isRequired,
    sizeUnit: PropTypes.string.isRequired,
  }).isRequired,
  values: PropTypes.shape({
    spaces: PropTypes.arrayOf(PropTypes.shape(spaceShape)),
  }),
};

export default ProposalSpaces;
